// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart {
  box-sizing: border-box;
  width: min(100%, 400px);
  padding: 22px 16px 24px;
  background: #ffffff;
  border: 2px solid #a78c83;
  border-radius: 32px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cart__title {
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 32px;
  line-height: 38px;
  color: #4e3f3a;
}

/* Переключатель Доставка / Самовывоз */
.cart__toggle-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 42px;
  padding: 4px;
  background: #f3e3cc;
  border: 2px solid #a78c83;
  border-radius: 21px;
  display: flex;
  gap: 4px;
}

.cart__toggle-btn {
  flex: 1;
  border: none;
  border-radius: 18px;
  background: transparent;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  color: #4e3f3a;
  cursor: pointer;
}

.cart__toggle-btn--active {
  background: #ff9702;
}

/* Адрес: кнопка + поле с текстом */
.cart__address-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.cart__address-btn {
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f3e3cc;
  border: 2px solid #a78c83;
  border-radius: 20px;
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  color: #4e3f3a;
  text-align: left;
  flex-shrink: 0;
}

.cart__address-btn:hover {
  background: #ebe0d0;
}

.cart__address-btn-label {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cart__address-value {
  box-sizing: border-box;
  width: 100%;
  min-height: 44px;
  padding: 8px 10px;
  margin: 0;
  background: #faf7f4;
  border: 1px solid #e8e4df;
  border-radius: 12px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4;
  color: #4e3f3a;
  word-wrap: break-word;
  overflow-wrap: anywhere;
}

.cart__address-icon--geo {
  width: 11px;
  height: auto;
  flex-shrink: 0;
}

.cart__address-icon--arrow {
  width: 16px;
  height: 14px;
  flex-shrink: 0;
}

.cart__restaurant-block {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.cart__restaurant-label {
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #4e3f3a;
}

.cart__restaurant-hint {
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  line-height: 1.35;
  color: #6b5c56;
}

.cart__restaurant-warn {
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  line-height: 1.35;
  color: #b45309;
}

.cart__restaurant-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 140px;
  overflow-y: auto;
}

.cart__restaurant-btn {
  width: 100%;
  text-align: left;
  padding: 8px 10px;
  border: 2px solid #e8e4df;
  border-radius: 10px;
  background: #fff;
  color: #4e3f3a;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  line-height: 1.3;
  cursor: pointer;
}

.cart__restaurant-btn:hover {
  border-color: #a78c83;
}

.cart__restaurant-btn--active {
  border-color: #a78c83;
  background: #faf7f5;
  font-weight: 600;
}

/* Список товаров */
.cart__list-wrap {
  box-sizing: border-box;
  flex: 0 0 auto;
  min-height: 100px;
  max-height: 320px;
  padding: 12px;
  background: #f3e3cc;
  border: 2px solid #a78c83;
  border-radius: 27px;
  overflow-y: auto;
}

.cart__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.cart__list-empty {
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  color: #4e3f3a;
  opacity: 0.7;
  text-align: center;
  padding: 24px 0;
}

.cart__item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  border-bottom: 1px solid rgba(167, 140, 131, 0.3);
}

.cart__item:last-child {
  border-bottom: none;
}

.cart__item-btn {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
  color: #4e3f3a;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.cart__item-btn:hover {
  background: rgba(255, 151, 2, 0.3);
}

.cart__item-name {
  flex: 1;
  min-width: 0;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 1.3;
  color: #4e3f3a;
  word-wrap: break-word;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.cart__item--unavailable .cart__item-name-text {
  color: #8a7a72;
  text-decoration: line-through;
}

.cart__item-unavailable-tag {
  display: inline-block;
  align-self: flex-start;
  padding: 1px 6px;
  background: #f3d4d6;
  color: #b32129;
  border-radius: 8px;
  font-size: 11px;
  line-height: 14px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.cart__item-remove-btn {
  flex-shrink: 0;
  border: 1px solid #df484f;
  background: transparent;
  color: #df484f;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 1;
  padding: 6px 10px;
  border-radius: 14px;
  cursor: pointer;
}

.cart__item-remove-btn:hover {
  background: #df484f;
  color: #ffffff;
}

/* Итог и кнопка заказа */
.cart__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 4px;
}

.cart__total {
  flex: 1;
  min-width: 0;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #4e3f3a;
}

.cart__submit-btn {
  flex: 0 1 65%;
  max-width: 65%;
  box-sizing: border-box;
  height: 46px;
  min-width: 0;
  padding: 0 20px;
  background: #df484f;
  border: 2px solid #a78c83;
  border-radius: 24.5px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  color: #ffffff;
  cursor: pointer;
}

.cart__submit-btn:hover:not(:disabled) {
  background: #c93d44;
}

.cart__submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.cart__bonus {
  padding: 10px 0 4px;
  border-top: 1px solid #e8dcd4;
  font-size: 13px;
  line-height: 1.35;
  color: #5c4a44;
}

.cart__bonus-line {
  margin: 0 0 6px;
}

.cart__bonus-hint {
  margin: 0;
  font-size: 12px;
  color: #8a7a72;
}

@media (max-width: 1100px) {
  .cart {
    width: 100%;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
  }
}

@media (max-width: 768px) {
  .cart {
    max-width: none;
    border-radius: 24px;
    padding: 16px 12px 16px;
  }

  .cart__title {
    font-size: 26px;
    line-height: 1.2;
  }

  .cart__toggle-btn,
  .cart__address-btn {
    font-size: 16px;
  }

  .cart__footer {
    flex-direction: column;
    align-items: stretch;
  }

  .cart__submit-btn {
    flex: 1 1 auto;
    max-width: none;
    width: 100%;
  }
}

@media (max-width: 430px) {
  .cart {
    border-radius: 20px;
    padding: 14px 10px 14px;
    gap: 10px;
  }

  .cart__toggle-btn,
  .cart__address-btn {
    font-size: 15px;
    line-height: 1.2;
  }

  .cart__list-wrap {
    max-height: 260px;
    border-radius: 20px;
    padding: 10px;
  }

  .cart__total {
    font-size: 18px;
    line-height: 1.25;
  }

  .cart__submit-btn {
    height: 42px;
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Cart.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".cart {\n  box-sizing: border-box;\n  width: min(100%, 400px);\n  padding: 22px 16px 24px;\n  background: #ffffff;\n  border: 2px solid #a78c83;\n  border-radius: 32px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.cart__title {\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 32px;\n  line-height: 38px;\n  color: #4e3f3a;\n}\n\n/* Переключатель Доставка / Самовывоз */\n.cart__toggle-wrap {\n  box-sizing: border-box;\n  width: 100%;\n  height: 42px;\n  padding: 4px;\n  background: #f3e3cc;\n  border: 2px solid #a78c83;\n  border-radius: 21px;\n  display: flex;\n  gap: 4px;\n}\n\n.cart__toggle-btn {\n  flex: 1;\n  border: none;\n  border-radius: 18px;\n  background: transparent;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 21px;\n  color: #4e3f3a;\n  cursor: pointer;\n}\n\n.cart__toggle-btn--active {\n  background: #ff9702;\n}\n\n/* Адрес: кнопка + поле с текстом */\n.cart__address-block {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.cart__address-btn {\n  box-sizing: border-box;\n  width: 100%;\n  height: 40px;\n  padding: 0 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #f3e3cc;\n  border: 2px solid #a78c83;\n  border-radius: 20px;\n  cursor: pointer;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 21px;\n  color: #4e3f3a;\n  text-align: left;\n  flex-shrink: 0;\n}\n\n.cart__address-btn:hover {\n  background: #ebe0d0;\n}\n\n.cart__address-btn-label {\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cart__address-value {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 44px;\n  padding: 8px 10px;\n  margin: 0;\n  background: #faf7f4;\n  border: 1px solid #e8e4df;\n  border-radius: 12px;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #4e3f3a;\n  word-wrap: break-word;\n  overflow-wrap: anywhere;\n}\n\n.cart__address-icon--geo {\n  width: 11px;\n  height: auto;\n  flex-shrink: 0;\n}\n\n.cart__address-icon--arrow {\n  width: 16px;\n  height: 14px;\n  flex-shrink: 0;\n}\n\n.cart__restaurant-block {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n}\n\n.cart__restaurant-label {\n  font-family: 'Roboto', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: #4e3f3a;\n}\n\n.cart__restaurant-hint {\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  font-size: 13px;\n  line-height: 1.35;\n  color: #6b5c56;\n}\n\n.cart__restaurant-warn {\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  font-size: 13px;\n  line-height: 1.35;\n  color: #b45309;\n}\n\n.cart__restaurant-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: 140px;\n  overflow-y: auto;\n}\n\n.cart__restaurant-btn {\n  width: 100%;\n  text-align: left;\n  padding: 8px 10px;\n  border: 2px solid #e8e4df;\n  border-radius: 10px;\n  background: #fff;\n  color: #4e3f3a;\n  font-family: 'Roboto', sans-serif;\n  font-size: 13px;\n  line-height: 1.3;\n  cursor: pointer;\n}\n\n.cart__restaurant-btn:hover {\n  border-color: #a78c83;\n}\n\n.cart__restaurant-btn--active {\n  border-color: #a78c83;\n  background: #faf7f5;\n  font-weight: 600;\n}\n\n/* Список товаров */\n.cart__list-wrap {\n  box-sizing: border-box;\n  flex: 0 0 auto;\n  min-height: 100px;\n  max-height: 320px;\n  padding: 12px;\n  background: #f3e3cc;\n  border: 2px solid #a78c83;\n  border-radius: 27px;\n  overflow-y: auto;\n}\n\n.cart__list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.cart__list-empty {\n  font-family: 'Roboto', sans-serif;\n  font-size: 14px;\n  color: #4e3f3a;\n  opacity: 0.7;\n  text-align: center;\n  padding: 24px 0;\n}\n\n.cart__item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 0;\n  border-bottom: 1px solid rgba(167, 140, 131, 0.3);\n}\n\n.cart__item:last-child {\n  border-bottom: none;\n}\n\n.cart__item-btn {\n  width: 28px;\n  height: 28px;\n  flex-shrink: 0;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 28px;\n  color: #4e3f3a;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n\n.cart__item-btn:hover {\n  background: rgba(255, 151, 2, 0.3);\n}\n\n.cart__item-name {\n  flex: 1;\n  min-width: 0;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 1.3;\n  color: #4e3f3a;\n  word-wrap: break-word;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.cart__item--unavailable .cart__item-name-text {\n  color: #8a7a72;\n  text-decoration: line-through;\n}\n\n.cart__item-unavailable-tag {\n  display: inline-block;\n  align-self: flex-start;\n  padding: 1px 6px;\n  background: #f3d4d6;\n  color: #b32129;\n  border-radius: 8px;\n  font-size: 11px;\n  line-height: 14px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.cart__item-remove-btn {\n  flex-shrink: 0;\n  border: 1px solid #df484f;\n  background: transparent;\n  color: #df484f;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 1;\n  padding: 6px 10px;\n  border-radius: 14px;\n  cursor: pointer;\n}\n\n.cart__item-remove-btn:hover {\n  background: #df484f;\n  color: #ffffff;\n}\n\n/* Итог и кнопка заказа */\n.cart__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 4px;\n}\n\n.cart__total {\n  flex: 1;\n  min-width: 0;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n  color: #4e3f3a;\n}\n\n.cart__submit-btn {\n  flex: 0 1 65%;\n  max-width: 65%;\n  box-sizing: border-box;\n  height: 46px;\n  min-width: 0;\n  padding: 0 20px;\n  background: #df484f;\n  border: 2px solid #a78c83;\n  border-radius: 24.5px;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 21px;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.cart__submit-btn:hover:not(:disabled) {\n  background: #c93d44;\n}\n\n.cart__submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.cart__bonus {\n  padding: 10px 0 4px;\n  border-top: 1px solid #e8dcd4;\n  font-size: 13px;\n  line-height: 1.35;\n  color: #5c4a44;\n}\n\n.cart__bonus-line {\n  margin: 0 0 6px;\n}\n\n.cart__bonus-hint {\n  margin: 0;\n  font-size: 12px;\n  color: #8a7a72;\n}\n\n@media (max-width: 1100px) {\n  .cart {\n    width: 100%;\n    max-width: 400px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n@media (max-width: 768px) {\n  .cart {\n    max-width: none;\n    border-radius: 24px;\n    padding: 16px 12px 16px;\n  }\n\n  .cart__title {\n    font-size: 26px;\n    line-height: 1.2;\n  }\n\n  .cart__toggle-btn,\n  .cart__address-btn {\n    font-size: 16px;\n  }\n\n  .cart__footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .cart__submit-btn {\n    flex: 1 1 auto;\n    max-width: none;\n    width: 100%;\n  }\n}\n\n@media (max-width: 430px) {\n  .cart {\n    border-radius: 20px;\n    padding: 14px 10px 14px;\n    gap: 10px;\n  }\n\n  .cart__toggle-btn,\n  .cart__address-btn {\n    font-size: 15px;\n    line-height: 1.2;\n  }\n\n  .cart__list-wrap {\n    max-height: 260px;\n    border-radius: 20px;\n    padding: 10px;\n  }\n\n  .cart__total {\n    font-size: 18px;\n    line-height: 1.25;\n  }\n\n  .cart__submit-btn {\n    height: 42px;\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
